import React from 'react';
import './InfoCard.css';

const InfoCard = ({ icon, title, description, example }) => (
  <div className="info-card">
    <i className={`fas fa-${icon}`}></i>
    <h3>{title}</h3>
    <p>{description}</p>
    <div className="example">{example}</div>
  </div>
);

export default InfoCard; 